// extracted by mini-css-extract-plugin
export default {"previewHeader":"PIf1Yf","button":"pDdcqB","buttonLabelHidden":"LhKMdV","buttonLoader":"O4wZYy","goToDesktop":"IoLXTM"};